export default __webpack_public_path__ + "static/media/to.92ab4807.svg";